import { ChangeText } from './ChangeText'
import { LiveNumber } from './LiveNumber'
import styles from './IndexRibbon.module.css'

export interface RibbonItem { name: string; value: number; change: number; changePercent: number; decimals?: number }

export interface MarketStatus { state: 'open' | 'closed' | 'pre-open'; label: string }

export interface IndexRibbonProps {
  /** `null` = market data source not connected; `undefined` = loading. */
  items: RibbonItem[] | null | undefined
  status?: MarketStatus | null
  /** Landmark name; must be unique if several ribbons share a page. */
  label?: string
}

export function IndexRibbon({ items, status = null, label = 'Market indices' }: IndexRibbonProps) {
  return (
    <div className={styles.ribbon} role="region" aria-label={label}>
      {items === undefined && <span className={styles.muted}>Loading indices…</span>}
      {items === null && (
        <span className={styles.notConnected}>
          <span className={styles.plug} aria-hidden="true" />Index &amp; commodity prices: data not connected
        </span>
      )}
      {items && items.length > 0 && (
        <ul className={styles.list} tabIndex={0} aria-label="Index values (scrolls sideways on small screens)">
          {items.map(i => (
            <li key={i.name} className={styles.item}>
              <span className={styles.name}>{i.name}</span>
              <LiveNumber className={styles.value} value={i.value} decimals={i.decimals ?? 2} />
              <ChangeText absolute={i.change} percent={i.changePercent} size="sm" decimals={i.decimals ?? 2} />
            </li>
          ))}
        </ul>
      )}
      <span className={styles.spacer} />
      {status && (
        <span className={`${styles.status} ${styles[status.state]}`}>
          <span className={styles.statusDot} aria-hidden="true" />{status.label}
        </span>
      )}
    </div>
  )
}
